module.exports = __webpack_public_path__ + "img/giwa.7f67ecce.jpg";